import { render, staticRenderFns } from "./undoButtonOn.vue?vue&type=template&id=db3e8ab2&"
import script from "./undoButtonOn.vue?vue&type=script&lang=ts&"
export * from "./undoButtonOn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports